
import QuestionTitle from '@/components/Question/QuestionTitle.vue';
import QuestionOptionInput from '@/components/Question/options/QuestionOptionInput.vue';
import QuestionDateInput from '@/components/Question/options/QuestionDateInput.vue';
// import TheGradient from '@/components/TheGradient.vue';
import RadioButton from '@/components/RadioButton.vue';
import SelectInput from '@/components/SelectInput.vue';
import {computed, defineComponent, onMounted, PropType, ref} from 'vue';
import {useStore} from "vuex";
import {key} from "@/store";
import SearchDropDown from '@/components/SearchDropDown.vue';
import SearchMultipleSelect from '@/components/SearchMultipleSelect.vue';
import {formatInTimeZone} from 'date-fns-tz';
import CalendarSvg from '@/assets/img/calendarSvg.vue';
import {PartnerReviewAnswerResource, PartnerReviewQuestionResource} from '@/api/partnerReviewApi';
import { QuestionResponseState } from '@/views/PartnerReviewSingleQuiz.vue';
import BaseButton from '@/components/BaseButton.vue';
import NewConfirmModal from '@/components/NewConfirmModal.vue';

import {Button, notification} from 'ant-design-vue';
export interface QuestionAcceptRejectEdit {
  state: 'accept' | 'reject' | 'edit' | null,
  isPopConfirmOpened: boolean,
  rejectReason: string,
  editValue: string,
}
export default defineComponent({
  name: 'AdminReviewSentRequestQuestionAnswer',
  components: {
    NewConfirmModal,
    BaseButton,
    CalendarSvg,
    SearchMultipleSelect,
    QuestionTitle,
    // TheGradient,
    QuestionOptionInput,
    RadioButton,
    SelectInput,
    SearchDropDown,
    QuestionDateInput,
  },
  props: {
    question: {
      type: Object as PropType<PartnerReviewQuestionResource & {user_answer?: string | string[], is_answer_changed?: boolean }>,
      required: true,
    },
    ix: {
      type: Number,
      required: true,
    },
    count: {
      type: Number,
      required: true,
    },
    isActive: {
      type: Boolean,
      required: true,
    },
    error :{
      type: String,
      required: true,
    },
    questionResponseState: {
      type: Object as PropType<Record<number, QuestionResponseState>>,
      required: true,
    }
  },
  emits: ['handleValueUpdate', 'setQuestionResponseState', 'handleReviewQuestion'],
  setup(props, ctx) {

    const store = useStore(key)
    const currentCategory = computed(() => store.state.currentCategory);
    const allCategories = computed(() => store.state.categories);

    const questionAcceptRejectEdit = ref<QuestionAcceptRejectEdit>({
      state: null,
      isPopConfirmOpened: false,
      rejectReason: '',
      editValue: '',
    })

    const handleValueUpdate = (val: string | Array<string>) => {
      console.log(val);
      ctx.emit('handleValueUpdate', props.question.id, val);
    }


    const handleYesNoChange = (answerValueId: string) => {
      handleValueUpdate([answerValueId]);
    };

    const arrayIncludeOrOmit = (array: Array<string>, value: string): Array<string> => {
      const ix = array.indexOf(value);
      if (ix !== -1) {
        array.splice(ix, 1);
      } else {
        array.push(value);
      }
      return array;
    };

    const handleMultipleChange = (answerValueId: string) => {
      let res: Array<string> = [];
      if (props.question.user_answer === null || typeof props.question.user_answer === 'string') {
        res = arrayIncludeOrOmit(res, answerValueId);
      } else if (props.question.user_answer !== undefined) {
        res = arrayIncludeOrOmit(props.question.user_answer, answerValueId);
      }
      handleValueUpdate(res);
    };

    const handleSelectChange = (answerValueId: string) => {
      console.log(answerValueId)
      handleValueUpdate([answerValueId]);
    };

    const handleSearchSelectChange = (v: {id: string, name: string}) => {
      console.log({
        x: v,
      })
      handleValueUpdate([v.id]);
    }
    const isResponseSelected = (answerValueId: string) => {
      if (typeof props.question.user_answer === 'string' || props.question.user_answer === null) {
        return false;
      } else if( props.question.user_answer !== undefined) {
        return props.question.user_answer.includes(answerValueId);
      }
    };

    type IgetSelectInputOptionsReturn = Array<{ label: string, value: string}>;
    const getSelectInputOptions = (
      answerValues: Record<string, string>,
    ): IgetSelectInputOptionsReturn => {
      const response: IgetSelectInputOptionsReturn = [];
      Object.keys(answerValues).forEach((key) => {
        response.push({
          label: answerValues[key], value: key,
        });
      });
      return response;
    };
    const getSearchSelectInputOptions = (
      answerValues: Record<string, string>,
    ): Array<{ name: string, id: string}> => {
      const response: Array<{ name: string, id: string}> = [];
      Object.keys(answerValues).forEach((key) => {
        response.push({
          name: answerValues[key], id: key,
        });
      });
      return response;
    };

    const renderAnswerValue =  (value: PartnerReviewAnswerResource, question:  PartnerReviewQuestionResource & {user_answer?: string | string[], is_answer_changed?: boolean}) => {
      if(Array.isArray(value.answer_value) && question.answer_values !== null) {
        return question.answer_values[value.answer_value[0]]
      }
      return value.answer_value
    }

    const formatDate = (date: string) => {
      // eslint-disable-next-line max-len
      return formatInTimeZone(new Date(date), Intl.DateTimeFormat().resolvedOptions().timeZone, 'MMM d, yyyy HH:MM');
    };

    return {
      handleValueUpdate,
      handleYesNoChange,
      isResponseSelected,
      handleMultipleChange,
      getSelectInputOptions,
      handleSelectChange,
      currentCategory,
      allCategories,
      getSearchSelectInputOptions,
      handleSearchSelectChange,

      renderAnswerValue,
      formatDate,

      questionAcceptRejectEdit,

    };
  },
});
